module.exports = __webpack_public_path__ + "static/media/image_partners_hop_sport.437637a1.jpg";